module.exports = __webpack_public_path__ + "static/media/metawheel1.f8c4ffb5.png";